import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { useShop } from "@/context/ShopContext";
import TermsBody from "@/components/TermsBody";

export default function Terms() {
  const navigate = useNavigate();
  const { shop } = useShop();
  return (
    <div className="mx-auto max-w-2xl px-4 py-6">
      <div className="flex items-center gap-2 pb-4">
        <button onClick={() => navigate(-1)} className="flex h-10 w-10 items-center justify-center rounded-full hover:bg-secondary">
          <ChevronLeft className="h-6 w-6" />
        </button>
        <h1 className="font-display text-xl font-bold">Terms & Care Policy</h1>
      </div>
      <TermsBody shop={shop} />
    </div>
  );
}
